import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { Department } from "./department";
import { WorkFlowDetails } from "./workflowdetails";
import { Act } from "./act";


export class WorkFlow extends EntityDto implements IEntityDto {

  WorkFlowDetails_Id:string;
  WorkFlow_Id: string;
  WorkFlowCode: string;
  WorkFlowName: string;
  IsActive: boolean;
  departments: Array<Department>;
  TotalCount: number;
  WorkFlowType_Id:number;
  WorkFlowOrder:Number;
  WorkFlowDetailsarray: Array<WorkFlowDetails>;
  MeetingType_Id:any;
  MeetingTypeName:string;
  MettingTypeCombo:Array<MeetingType>
  Description:string;
  EditBit: Number;

  constructor() {
    super();
    this.WorkFlowDetails_Id='00000000-0000-0000-0000-000000000000';
    this.WorkFlow_Id ='00000000-0000-0000-0000-000000000000';
    this.WorkFlowCode = '';
    this.WorkFlowName = '';
    this.TotalCount = 0;
    this.IsActive = true;
    this.departments = [];
    this.WorkFlowType_Id = 0;
    this.WorkFlowOrder = 0;
    this.WorkFlowDetailsarray=[];
    this.MeetingType_Id="00000000-0000-0000-0000-000000000000"
    this.MeetingTypeName="";
    this.MettingTypeCombo=[];
    this.Description="";
    this.EditBit=0;

    this.EntityMetaData = [
      { FieldName: 'WorkFlowCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Code is required' },
      //{ FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' },
      { FieldName: 'WorkFlowName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Name is required' },
      {FieldName:'MeetingType_Id',FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Group is required'}
    ];
  }
}
export class MeetingType
{
  CommitteeName:string;
  Committee_Id:string;
  constructor()
  {
    this.CommitteeName="";
    this.Committee_Id="";

  }
}